import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
} from "./SidebarElements";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink
            to="aboutus"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            เกี่ยวกับเรา
          </SidebarLink>
          <SidebarLink
            to="whatwebelieve"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            หลักข้อเชื่อ
          </SidebarLink>
          <SidebarLink
            to="leadership"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            ผู้นำคริสตจักร
          </SidebarLink>
          <SidebarLink
            to="contactus"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            ติดต่อเรา
          </SidebarLink>
        </SidebarMenu>
        {/* <SideBtnWrap>
          <SidebarRoute to="/donate">Donate</SidebarRoute>
        </SideBtnWrap> */}
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
